import { useNavigationType } from 'react-router-dom';
import { Action } from '@remix-run/router';

import { NewsEvent } from '@/modules/calendar/model/calendar/news-event';
import AuctionDetails from '@/modules/calendar/components/data-calendar/details/auction-details';
import {
  useWidgetNavigate,
  useWidgetLoaderData,
  useWidgetParams,
  useWidgetSearchParams,
} from '@/core/widgets/export';

export default function AuctionEventPage() {
  const navigate = useWidgetNavigate();
  const searchParams = useWidgetSearchParams();
  const view = searchParams.get('view');
  const date = searchParams.get('date');
  const { auctionHolderId } = useWidgetParams();
  const events = useWidgetLoaderData();
  const navigationType = useNavigationType();

  return (
    <>
      <AuctionDetails
        date={date || ''}
        auctionHolderId={auctionHolderId || ''}
        events={events as NewsEvent[]}
        onClose={() => {
          if (navigationType === Action.Push) {
            navigate(-1);
          } else {
            const targetView = view || 'daily';
            const targetDate = date || (events as NewsEvent[])[0]?.date || 'today';
            navigate(`/${targetView}/${targetDate}`);
          }
        }}
      />
    </>
  );
}
